import * as Dialog from "@radix-ui/react-dialog";
import {Field, FieldInputProps, FieldMetaProps, Form, Formik} from "formik";
import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {updateListingLeadStatus} from "../../services/api";
import {setRefetch, setRefetchDetails, setRefetchStatus,} from "../../store/reducers/listingReducer";
import {ReactComponent as CloseIcon} from "../../assets/svg/x-close.svg";

interface IProps {
    isOpen: boolean;
    close: () => void;
    currentListing: any;
}

export const UpdateLeadStatus = (props: IProps) => {
    const [errorMessage, setErrorMessage] = useState("");
    const dispatch = useDispatch();
    const leadStatusOptions = useSelector(
        (state: any) => state.listingReducer.leadStatusOptions
    );

    async function updateLeadStatus(values: any) {
        setErrorMessage("");
        let params: any = {};
        params["lead_status"] = values.lead_status;
        params["listing_unique_id"] = props.currentListing.listing_unique_id;
        await updateListingLeadStatus(params);
        dispatch(setRefetch(true));
        dispatch(setRefetchStatus(true));
        dispatch(setRefetchDetails(true));
        props.close();
    }

    return (
        <Dialog.Root open={props.isOpen}>
            <Dialog.Portal>
                <Dialog.Overlay className="bg-gray-800 bg-opacity-60 fixed inset-0 z-40"/>
                <Dialog.Content
                    style={{transform: "translate(-50%, -50%)"}}
                    className="fixed left-1/2 top-1/2 bg-white p-6 z-40 min-w-[30rem]"
                >
                    <Dialog.Title className="text-gray-900 text-lg font-semibold">
                        Update Lead Status
                    </Dialog.Title>

                    <Dialog.Close>
                        <button onClick={props.close} className="absolute top-6 right-6">
                            <CloseIcon/>
                        </button>
                    </Dialog.Close>
                    <Formik
                        initialValues={{
                            lead_status: props.currentListing?.lead_status_options_public_id,
                        }}
                        onSubmit={async (val: any) => {
                            updateLeadStatus(val);
                        }}
                    >
                        <Form>
                            <div className="flex flex-col gap-y-3">
                                <label className="text-sm font-medium text-gray-700">
                                    Lead Status
                                </label>
                                <Field name="lead_status">
                                    {({
                                          field,
                                          meta,
                                      }: {
                                        field: FieldInputProps<any>;
                                        meta: FieldMetaProps<any>;
                                    }) => (
                                        <div>
                                            <select
                                                className="border px-4 py-2 outline-none w-full"
                                                {...field}
                                            >
                                                <option value="">Please select</option>
                                                {leadStatusOptions.map((options: any) => (
                                                    <option
                                                        value={options.public_id}
                                                        key={
                                                            "listing-info-lead-status-options-" +
                                                            options.public_id
                                                        }
                                                    >
                                                        {options.option_name}
                                                    </option>
                                                ))}
                                            </select>
                                            {meta.touched && meta.error && (
                                                <div className="text-xs text-red-500 mt-2">
                                                    {meta.error}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </Field>
                            </div>

                            {errorMessage ? (
                                <div className="p-3 bg-red-400 text-white mt-4">
                                    {errorMessage}
                                </div>
                            ) : null}

                            <div className="mt-4 flex w-full justify-end gap-x-4">
                                <button
                                    className="px-4 py-2 border"
                                    onClick={props.close}
                                    type="button"
                                >
                                    Close
                                </button>
                                <button
                                    className="px-4 py-2 bg-primary text-white"
                                    type="submit"
                                >
                                    Save
                                </button>
                            </div>
                        </Form>
                    </Formik>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
